import { Controller } from "@hotwired/stimulus";

// Generic expand/collapse for a hidden detail region (e.g. an edit drawer row
// under a compact table row). The trigger button carries the action; the region
// to reveal is the "detail" target.
//
//   <button data-action="disclosure#toggle" aria-expanded="false">Modifier</button>
//   <tr class="hidden" data-disclosure-target="detail">…</tr>
export default class extends Controller {
  static targets = ["detail"];

  toggle(event) {
    const hidden = this.detailTarget.classList.toggle("hidden");
    const trigger = event?.currentTarget;
    if (trigger) trigger.setAttribute("aria-expanded", String(!hidden));
  }
}
